export default class PowMonLimit {
    constructor(dataType, limit, alarmLevel, name) {
        this.dataType = dataType;
        this.limit = limit;
        this.alarmLevel = alarmLevel;
        this.name = name;
    }
}
